import React, { useState, useEffect } from 'react';
import toast from 'react-simple-toasts';

import { Icon, IconClose } from '../../../base/icons';
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from '../../../webjam/constant';
import { setToolsObject } from '../../redux/tool-webjam-v2/actions';
import { dispatch } from '../../Utils';
import { getLJsonStorage } from '../../welcome-dashboard/Utils';

// css for guitar scale
import './guitar-scale.css';
import { ct } from '../../constant-Utils';

const GuitarScale = (props) => {
  const { socket, Sessions, closeTool, toolOpenLocal, toolDetail } = props;
  const [html, setHtml] = useState('<div></div>');

  // hide buttons and cross buttons
  const [isDisable, setIsDisable] = useState(false);
  const [isResult, setIsResult] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [isLocalUser, setIsLocalUser] = useState(false);

  // setting the default options
  const [options, setOptions] = useState({
    id_root: toolDetail?.guitarScale ? toolDetail?.guitarScale?.id_root : "Please Select",
    id_pattern: toolDetail?.guitarScale ? toolDetail?.guitarScale?.id_pattern : "Please Select"
  });

  const { openByUser, SessionId } = Sessions;

  useEffect(() => {
    if (toolDetail) {
      if (Object.keys(toolDetail).length) {
        if (toolDetail?.isSocket == true) {
          let count = 1;
          if (count == 1) {
            setShowButtons(true);
            count++;
          }
          setOptions({
            ...options,
            id_root: toolDetail[0],
            id_pattern: toolDetail[1]
          })
          generateScale({
            id_root: toolDetail[0],
            id_pattern: toolDetail[1]
          });
        }
      }
    }
  }, [toolDetail])

  // setting the audio stream
  useEffect(() => {
    if (SessionId === openByUser) {
      setIsDisable(true);

      // emit data for all user
      socket.emit("openTools_fromtool", {
        openTool: 'guitar-scale',
        SessionId: Sessions.openByUser,
        location: CURRENT_ROOM_LOCATION
      });
      if (showButtons) {
        setIsDisable(false);
      }
    }

    socket.on("show_fretboard_data", (data) => {
      const { room, params } = data;
      if (room === CURRENT_ROOM_LOCATION) {
        setOptions({
          id_root: params[0],
          id_pattern: params[1]
        });

        setHtml(data.html);
        setIsResult(true)
      }
    });

    return function cleanup() {
      // unsubscribe the listener
      socket.off('show_fretboard_data');
    };
  }, [openByUser, toolDetail]);

  const changeOptions = (e) => {
    // setting the options
    const { target: { name, value } } = e;

    setOptions({
      ...options,
      [name]: value
    });
  };

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  // generating the scale
  const generateScale = (data = "") => {

    let { id_root, id_pattern } = options;
    if (data != "") {
      id_root = data.id_root
      id_pattern = data.id_pattern
    }
    if (id_root == 'Please Select' || id_pattern == 'Please Select') {
      setIsResult(false)
      toast(ct("Translate.messages.selectValues"), Constant.App.ToastTime.LongCloseTime)
    } else {
      setIsResult(true)
      const scale = id_root.replace("#", "%23");
      const pattern = id_pattern.replace(" ", "");
      const string = scale + pattern.replace(" ", "");

      const json = {};
      json.room = CURRENT_ROOM_LOCATION;
      json.params = [id_root, id_pattern];
      json.data = string;
      json.isFretboardOpen = true;
      json.roomName = CURRENT_ROOM_NAME;
      // emit data for all user
      socket.emit("openTools_fromtool", {
        openTool: 'guitar-scale',
        SessionId: Sessions.openByUser,
        location: CURRENT_ROOM_LOCATION
      });

      // Sleep for one second
      sleep(500).then(() => {
        socket.emit("show_fretboard_data", json);
      });

      if (props.openToolStatus) {
        props.openToolStatus(
          json
        )
      }

      dispatch(setToolsObject(json));
    }
  }

  useEffect(() => {
    if (props.toolOpenLocal) {
      setIsLocalUser(true)
    }
  }, []);

  const isGuestAccount = getLJsonStorage("auth", "guest_id");

  return (
    <div className="fretboard-outer" style={{ minHeight: '300px' }}>
      <div id="metronome">
        {!isGuestAccount && <div
          className='close-side-bar'
          id='guitar-close-icon-wrapper'
          onClick={closeTool}>
          <Icon src={IconClose} containerId="guitar-close-icon" />
        </div>}
        <div id="metronomeBg">
          <div className="fretwrapper">
            <div id="guitar-scale-container_main">
              <div className="chicletSection">
                <div className="selectors bottomForm">
                  <div className="scale_container_wrapper">
                    <div className="activeApp">
                      <center>
                        <form className="entryForm" id="form_data_chord" onSubmit={(e) => e.preventDefault()}>
                          <input type="hidden" id="id_optionsDisp" name="optionsDisp" defaultValue="none" />
                          <input type="hidden" id="id_selLeft" name="selLeft" defaultValue={102} />
                          <input type="hidden" id="id_menuTab" name="menuTab" defaultValue="instructions" />
                          <span className="next_scale">{ct("rta-trmc.tools.nextScale")}:</span>
                          <select id="id_root" onChange={changeOptions} name="id_root" value={options?.id_root}>
                            <option defaultValue="Please Select" disabled>{ct("rta-trmc.tools.pleaseSelect")}</option>
                            <option value="A">A</option>
                            <option value="A#">A#/Bb</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="C#">C#/Db</option>
                            <option value="D">D</option>
                            <option value="D#">D#/Eb</option>
                            <option value="E">E</option>
                            <option value="F">F</option>
                            <option value="F#">F#/Gb</option>
                            <option value="G">G</option>
                            <option value="G#">G#/Ab</option>
                          </select>

                          <select id="id_pattern" onChange={changeOptions} name="id_pattern" value={options?.id_pattern}>
                            <option defaultValue="Please Select" disabled>{ct("rta-trmc.tools.pleaseSelect")}</option>
                            <option value="major">{ct("rta-trmc.tools.major")}</option>
                            <option value="pentatonic minor">{ct("rta-trmc.tools.pentatonic_minor")}</option>
                            <option value="blues">{ct("rta-trmc.tools.blues")}</option>
                            <option value="pentatonic major">{ct("rta-trmc.tools.pentatonic_major")}</option>
                            <option value="natural minor">{ct("rta-trmc.tools.natural_minor")}</option>
                            <option value="harmonic minor">{ct("rta-trmc.tools.harmonic_minor")}</option>
                            <option value="melodic minor (ascending)">{ct("rta-trmc.tools.melodic_minor_asc")}</option>
                            <option value="melodic minor (descending)">{ct("rta-trmc.tools.melodic_minor_desc")}</option>
                            <option value="dorian">{ct("rta-trmc.tools.dorian")}</option>
                            <option value="phrygian">{ct("rta-trmc.tools.phrygian")}</option>
                            <option value="lydian">{ct("rta-trmc.tools.lydian")}</option>
                            {/* <option value="mixolydian">{ct("rta-trmc.tools.mixolydian")}</option> */}
                            <option value="locrian">{ct("rta-trmc.tools.locrian")}</option>
                            <option value="arabic">{ct("rta-trmc.tools.arabic")}</option>
                            <option value="hungarian gypsy">{ct("rta-trmc.tools.hungarian_gypsy")}</option>
                            <option value="whole tone">{ct("rta-trmc.tools.whole_tone")}</option>
                            <option value="augmented">{ct("rta-trmc.tools.augmented")}</option>
                            <option value="phrygian dominant">{ct("rta-trmc.tools.phrygian_dominant")}</option>
                          </select>
                          {(isLocalUser) &&
                            <input defaultValue={ct("rta-trmc.tools.generateScale")} onClick={() => generateScale()} id="id_submitButton" alt="go" title="go" className="btn" type="button" />
                          }
                        </form>
                      </center>
                    </div>
                  </div>
                </div>
              </div>
              {
                isResult ? <div id="datagoeshere"><div dangerouslySetInnerHTML={{ __html: html }} className="results" ></div></div> : <div id="datagoeshere">{ct("rta-trmc.tools.selectAndGenerate")}</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuitarScale;
